import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { OpenIdLoginRoutingModule } from './openIdLogin-routing.module';
import { OpenIdLoginComponent } from './openIdLogin.component';
import {TranslateModule} from '@ngx-translate/core';

@NgModule({
  imports: [
    CommonModule,
    OpenIdLoginRoutingModule,
    TranslateModule,
    FormsModule,  
    ReactiveFormsModule,  
  ],
  declarations: [OpenIdLoginComponent]
})
export class OpenIdLoginModule { }


